// -----------------------------------------------------------------------------
// Single source of truth for Projection modes.
// Each entry carries the legacy numeric id AND the UI label.
// From this registry we derive:
// - a literal union type of ids (ProjectionModeId)
// - a flat options array for the UI (PROJECTION_OPTIONS)
// - an optional numeric map for compatibility (PROJECTION.STANDARD, etc.)
// -----------------------------------------------------------------------------
import { getSentence } from './sentences';

export const PROJECTION_MODES = {
    STANDARD: { id: 0, label: 'No' },
    HORIZONTAL: { id: 1, label: 'Horizontal' },
    FIXED_AVG: { id: 2, label: 'Average' },
    ORTHOGONAL: { id: 3, label: 'Orthogonal' },
} as const;

export const getProjectionTooltip = (id: number) => {
    switch (id) {
        case 1:
            return getSentence('Filter.Projections.Horizontal.Tooltip');
        case 2:
            return getSentence('Filter.Projections.FixedAverage.Tooltip');
        case 3:
            return getSentence('Filter.Projections.MovingAverage.Tooltip');
        case 4:
            return getSentence('Filter.Projections.Orthogonal.Tooltip');
        default:
            return '';
    }
};

// Keys of the regestry
export type ProjectionKey = keyof typeof PROJECTION_MODES;

// Union of numeric ids
export type ProjectionModeId = (typeof PROJECTION_MODES)[ProjectionKey]['id'];

// Flat array for UI components
export const PROJECTION_OPTIONS: ReadonlyArray<{ value: ProjectionModeId; label: string }> = Object.values(PROJECTION_MODES).map(
    ({ id, label }) => ({ value: id, label })
);

export const PROJECTION = Object.fromEntries(Object.entries(PROJECTION_MODES).map(([k, v]) => [k, v.id])) as {
    [K in ProjectionKey]: (typeof PROJECTION_MODES)[K]['id'];
};
